(function() {
  'use strict';

  function initCartUpsell() {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container || container.dataset.upsellInit) return;
    container.dataset.upsellInit = 'true';

    var checkboxes = container.querySelectorAll('[data-upsell-checkbox]');
    var addBtn = container.querySelector('[data-upsell-add-selected]');
    var countEl = container.querySelector('[data-upsell-count]');
    var totalEl = container.querySelector('[data-upsell-total]');
    var totalPriceEl = container.querySelector('[data-upsell-total-price]');
    var statusEl = container.querySelector('[data-upsell-status]');

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function updateUI() {
      var checked = Array.prototype.slice.call(checkboxes).filter(function(cb) {
        return cb.checked;
      });
      var count = checked.length;

      if (addBtn) addBtn.disabled = count === 0;
      if (countEl) countEl.textContent = count > 0 ? count : '';

      if (totalEl && totalPriceEl) {
        if (count > 0) {
          var total = checked.reduce(function(sum, cb) {
            return sum + parseInt(cb.dataset.price || 0, 10);
          }, 0);
          totalPriceEl.textContent = formatMoney(total);
          totalEl.style.display = '';
        } else {
          totalEl.style.display = 'none';
        }
      }

      checkboxes.forEach(function(cb) {
        var item = cb.closest('[data-upsell-item]');
        if (item) item.classList.toggle('cart-upsell__item--selected', cb.checked);
      });

      if (statusEl) {
        statusEl.textContent = '';
        statusEl.className = 'cart-upsell__status';
      }
    }

    function addToCart() {
      var checked = Array.prototype.slice.call(checkboxes).filter(function(cb) {
        return cb.checked;
      });
      if (!checked.length) return;

      var items = checked.map(function(cb) {
        return { id: parseInt(cb.value, 10), quantity: 1 };
      });

      addBtn.disabled = true;
      if (statusEl) statusEl.textContent = 'Aggiunta in corso...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Errore');
        return res.json();
      })
      .then(function() {
        if (statusEl) {
          statusEl.textContent = '✓ ' + items.length + ' prodott' + (items.length > 1 ? 'i aggiunti' : 'o aggiunto') + '!';
          statusEl.className = 'cart-upsell__status cart-upsell__status--success';
        }

        checkboxes.forEach(function(cb) { cb.checked = false; });
        updateUI();

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() { window.location.reload(); }, 800);
      })
      .catch(function() {
        if (statusEl) {
          statusEl.textContent = '✗ Errore durante l\'aggiunta';
          statusEl.className = 'cart-upsell__status cart-upsell__status--error';
        }
        addBtn.disabled = false;
      });
    }

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', updateUI);
    });
    if (addBtn) addBtn.addEventListener('click', addToCart);
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUpsell);
  } else {
    initCartUpsell();
  }

  document.addEventListener('shopify:section:load', initCartUpsell);
})();
